import { useTranslation } from "react-i18next";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsBank, BsBank2, BsChatTextFill, BsRobot } from "react-icons/bs";
import {
  FaBus,
  FaCar,
  FaCity,
  FaGlobeAsia,
  FaIndustry,
  FaList,
  FaRegCalendarAlt,
  FaRoute,
  FaSchool,
  FaStar,
  FaUserCog,
  FaUserTie,
} from "react-icons/fa";
import { PiStudent } from "react-icons/pi";
import { GrTransaction } from "react-icons/gr";
import { IoIosColorPalette } from "react-icons/io";
import { IoDocumentText } from "react-icons/io5";
import {
  RiDashboardFill,
  RiInfoCardLine,
  RiParentFill,
  RiSecurePaymentFill,
  RiUserSettingsLine,
} from "react-icons/ri";
import { SiSimpleanalytics, SiWebmoney } from "react-icons/si";
import Sidebar from "../Sidebar";
import "./VendorMenu.scss";
import {
  MdAccountBalance,
  MdFamilyRestroom,
  MdOutlinePayments,
  MdPayments,
  MdStorefront,
} from "react-icons/md";
import { FiCreditCard } from "react-icons/fi";
import { TbCreditCardPay, TbApps } from "react-icons/tb";
import { FaTaxi } from "react-icons/fa";

const SideMenu = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const { t } = useTranslation();
  const menus = [
    {
      type: "link",
      text: t("ask_ai"),
      icon: <BsRobot />,
      to: "/ask-ai",
    },

    {
      type: "link",
      text: t("dashboard"),
      icon: <RiDashboardFill />,
      to: "/dashboard",
    },

    // {
    //   type: "link",
    //   text: "Switch Project",
    //   icon: <TbApps />,
    //   to: "/switch-project",
    // },

    {
      type: "link",
      text: t("tracking"),
      icon: <FaRoute />,
      to: "/tracking",
    },

    {
      type: "link",
      text: `${t("my")} ${t("vendors")}`,
      icon: <FaCar />,
      to: "/vendors",
    },

    {
      type: "link",
      text: `${t("my")} ${t("schools")}`,
      icon: <FaSchool />,
      to: "/schools",
    },

    // -----------------------------
    // DRIVERS DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("all")} ${t("drivers")}`,
      icon: <FaUserTie />,
      children: [
        {
          type: "link",
          text: `${t("school")} ${t("drivers")}`,
          icon: <FaSchool />,
          to: "/school-drivers",
        },
        {
          type: "link",
          text: `${t("vendor")} ${t("drivers")}`,
          icon: <FaCar />,
          to: "/vendor-drivers",
        },
      ],
    },

    // -----------------------------
    // PARENTS DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("all")} ${t("parents")}`,
      icon: <RiParentFill />,
      children: [
        {
          type: "link",
          text: `${t("school")} ${t("parents")}`,
          icon: <MdFamilyRestroom />,
          to: "/school-parents",
        },
        {
          type: "link",
          text: `${t("vendor")} ${t("parents")}`,
          icon: <RiUserSettingsLine />,
          to: "/vendor-parents",
        },
      ],
    },

    {
      type: "link",
      text: `${t("user")} ${t("management")}`,
      icon: <FaUserCog />,
      to: "/user-management",
    },

    // -----------------------------
    // VEHICLES DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: t("vehicles"),
      icon: <FaBus />,
      children: [
        {
          type: "link",
          text: `${t("school")} ${t("vehicles")}`,
          icon: <FaSchool />,
          to: "/school-vehicles",
        },
        {
          type: "link",
          text: `${t("vendor")} ${t("vehicles")}`,
          icon: <FaCar />,
          to: "/vendor-vehicles",
        },
      ],
    },

    // -----------------------------
    // RESERVATIONS DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("all")} ${t("reservations")}`,
      icon: <FaList />,
      children: [
        {
          type: "dropdown",
          text: `${t("school")} ${t("reservations")}`,
          icon: <FaSchool />,
          children: [
            {
              type: "link",
              text: `${t("bus")} ${t("charter")}`,
              icon: <FaSchool />,
              to: "/school-bus-charter",
            },
            {
              type: "link",
              text: `${t("busing")} ${t("subscription")}`,
              icon: <FaCar />,
              to: "/school-busing-subscription",
            },
          ],
        },
        {
          type: "dropdown",
          text: `${t("vendor")} ${t("reservations")}`,
          icon: <FaCar />,
          children: [
            {
              type: "dropdown",
              text: `${t("Outsourced")} ${t("from")} ${t("school")}`,
              icon: <FaSchool />,
              children: [
                {
                  type: "link",
                  text: `${t("bus")} ${t("charter")}`,
                  icon: <FaSchool />,
                  to: "/transfer-bus-charter",
                },
                {
                  type: "link",
                  text: `${t("busing")} ${t("subscription")}`,
                  icon: <FaCar />,
                  to: "/transfer-busing-subscription",
                },
              ],
            },
            {
              type: "link",
              text: `${t("busing")} ${t("subscription")}`,
              icon: <FaCar />,
              to: "/vendor-busing-subscription",
            },
          ],
        },
      ],
    },

    // -----------------------------
    // RESERVATION HISTORY DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("reservations")} ${t("history")}`,
      icon: <FaRegCalendarAlt />,
      children: [
        {
          type: "link",
          text: `${t("rides")} ${t("completed")}`,
          icon: <FaRegCalendarAlt />,
          to: "/completed-rides",
        },
        {
          type: "link",
          text: `${t("cancel")} ${t("reservation")}`,
          icon: <FaRegCalendarAlt />,
          to: "/cancelled-reservations",
        },
        {
          type: "link",
          text: `${t("parent")} ${t("cancellations")}`,
          icon: <FaRegCalendarAlt />,
          to: "/parent-cancellations",
        },
      ],
    },

    {
      type: "link",
      text: `${t("reporting")} ${t("and")} ${t("analytics")}`,
      icon: <SiSimpleanalytics />,
      to: "/reporting-and-analytics",
    },
    {
      type: "dropdown",
      text: `${t("payments")}`,
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: `${t("make")} ${t("payment")}`,
          icon: <FiCreditCard />,
          to: "/make-payment",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payment")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment",
        },
      ],
    },
    // -----------------------------
    // PAYMENT HISTORY DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("payments")} ${t("history")}`,
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: `${t("school")} ${t("payments")} ${t("history")}`,
          icon: <SiWebmoney />,
          to: "/school-payment-history",
        },
        {
          type: "link",
          text: `${t("vendor")} ${t("payments")} ${t("history")}`,
          icon: <FaCar />,
          to: "/vendor-payment-history",
        },
        {
          type: "link",
          text: `${t("parent")} ${t("subscription")} ${t("history")}`,
          icon: <MdPayments />,
          to: "/parent-payment-history",
        },
        {
          type: "link",
          text: `${t("manual")} ${t("payments")} ${t("history")}`,
          icon: <TbCreditCardPay />,
          to: "/manual-payment-history",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payments")} ${t("history")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment-history",
        },
      ],
    },

    {
      type: "link",
      text: `${t("user")} ${t("communication")}`,
      icon: <BsChatTextFill />,
      to: "/user-communication",
    },

    // {
    //   type: "link",
    //   text: `${t("ratings")} ${t("and")} ${t("reviews")}`,
    //   icon: <FaStar />,
    //   to: "/admin/ratings-and-reviews",
    // },

    // -----------------------------
    // RATING & REVIEWS DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("ratings")} ${t("and")} ${t("reviews")}`,
      icon: <FaStar />,
      children: [
        {
          type: "link",
          text: `${t("school")} ${t("ratings")} ${t("and")} ${t("reviews")}`,
          icon: <FaStar />,
          to: "/school-ratings",
        },
        {
          type: "link",
          text: `${t("vendor")} ${t("ratings")} ${t("and")} ${t("reviews")}`,
          icon: <FaStar />,
          to: "/vendor-ratings",
        },
      ],
    },

    // -----------------------------
    // SYSTEM CONFIG DROPDOWN
    // -----------------------------
    {
      type: "dropdown",
      text: `${t("system")} ${t("configuration")}`,
      icon: <RiInfoCardLine />,
      children: [
        {
          type: "dropdown",
          text: `Banking ${t("details")}`,
          icon: <BsBank2 />,
          children: [
            {
              type: "link",
              text: `${t("admin")} ${t("bank")} ${t("account")} ${t("details")}`,
              icon: <MdAccountBalance />,
              to: "/bank-details",
            },
            {
              type: "link",
              text: `${t("school")} ${t("bank")} ${t("account")} ${t("details")}`,
              icon: <MdAccountBalance />,
              to: "/school-bank-details",
            },
            {
              type: "link",
              text: `${t("vendor")} ${t("bank")} ${t("account")} ${t("details")}`,
              icon: <MdStorefront />,
              to: "/vendor-bank-details",
            },
          ],
        },
        {
          type: "link",
          text: `${t("plans")} & ${t("payments")}`,
          icon: <BsBank />,
          to: "/payment-plans",
        },

        // SUB-DROPDOWN: MANAGE BUS FEE
        {
          type: "dropdown",
          text: `${t("manage")} ${t("bus")} ${t("fees")}`,
          icon: <AiFillDollarCircle />,
          children: [
            {
              type: "link",
              text: `${t("school")} ${t("bus")} ${t("fees")}`,
              icon: <FaSchool />,
              to: "/school-bus-fee",
            },
            {
              type: "link",
              text: `${t("vendor")} ${t("bus")} ${t("fees")}`,
              icon: <FaCar />,
              to: "/vendor-bus-fee",
            },
          ],
        },

        // SUB-DROPDOWN: VEHICLE VERIFICATIONS
        {
          type: "dropdown",
          text: `${t("vehicle")} ${t("verifications")}`,
          icon: <IoDocumentText />,
          children: [
            {
              type: "link",
              text: `${t("school")} ${t("document")}`,
              icon: <FaSchool />,
              to: "/school-vehicle-documents",
            },
            {
              type: "link",
              text: `${t("vendor")} ${t("document")}`,
              icon: <FaCar />,
              to: "/vendor-vehicle-documents",
            },
          ],
        },

        {
          type: "link",
          text: `${t("vehicle")} ${t("make")}`,
          icon: <FaIndustry />,
          to: "/vehicle-make",
        },
        {
          type: "link",
          text: `${t("vehicle")} ${t("model")}`,
          icon: <FaBus />,
          to: "/vehicle-model",
        },
        {
          type: "link",
          text: `${t("vehicle")} ${t("year")}`,
          icon: <FaRegCalendarAlt />,
          to: "/vehicle-year",
        },
        {
          type: "link",
          text: `${t("vehicle")} ${t("color")}`,
          icon: <IoIosColorPalette />,
          to: "/vehicle-color",
        },
        {
          type: "link",
          text: `${t("vehicle")} ${t("type")}`,
          icon: <FaBus />,
          to: "/vehicle-type",
        },
      ],
    },
  ];

  return (
    <>
      <Sidebar
        setCollapsedFromSidebar={setCollapsedFromSidebar}
        menu={menus}
        isCollapsed={isCollapsed}
        title="Admin"
      />
    </>
  );
};

export default SideMenu;
